import styled from "styled-components";

const LoginContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  h2{
    margin: 20px 20px;
    color: var(--leve-color);
  }
`;

const LoginForm = styled.form`
  width: 400px;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 0.5rem 3rem rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 150px;
    margin-bottom: 24px;
  }

  button {
    width: 100%;
    margin-top: 8px;
  }

  label{
    color: var(--regular-gray);
  }
`;

const LoginFormGroup = styled.div`
  margin-bottom: 10px;
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  font-size: var(--font-medium);
  font-weight: bold;  
  
`;

export { LoginContainer, LoginForm, LoginFormGroup };
